'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _validation = require('../common/validation');

var _validation2 = _interopRequireDefault(_validation);

require('./view.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

/**
 *
 * 配置带有 focus 提示气泡信息展示，需要配置对应的联动或异步规则
 * 下面展示的是拼接组件中的输入框 及 普通输入框配置气泡提示信息方式
 * "rules": [
    {
      "ruleId": "w0oao",
      "desc": "拼接组件输入提示",
      "condition": "${self.PJZJXR}.visible",
      "target": {
        "self.PJZJXR>XFDXWBCS": {
          "props": {
            "balloon": {
              "content": "输入提示信息展示区域",
              "align": "rt",
              "style": {
                "width": 200
              }
            }
          }
        }
      }
    },
    {
      "ruleId": "3fvjq",
      "desc": "输入信息展示",
      "condition": "${self.XFDXWBCS}.visible",
      "target": {
        "self.XFDXWBCS": {
          "props": {
            "balloon": {
              "content": "输入提示信息展示区域",
              "align": "rt",
              "style": {
                "width": 200
              }
            }
          }
        }
      }
    }
  ],
 *
 */

var InputField = (_temp = _class = function (_Field) {
  _inherits(InputField, _Field);

  function InputField() {
    _classCallCheck(this, InputField);

    return _possibleConstructorReturn(this, _Field.apply(this, arguments));
  }

  InputField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-input'
    });
  };

  /**
   * 填写状态的渲染
   * balloon是配置气泡提示信息，enableInputBalloon字段控制
   * @returns
   */


  InputField.prototype.renderControl = function renderControl() {
    var _props = this.props,
        inputType = _props.inputType,
        maxLength = _props.maxLength,
        _props$balloon = _props.balloon,
        balloon = _props$balloon === undefined ? {} : _props$balloon,
        _props$enableInputBal = _props.enableInputBalloon,
        enableInputBalloon = _props$enableInputBal === undefined ? true : _props$enableInputBal;

    var commonProps = this.getControlProps();

    var _ref = balloon || {},
        _ref$content = _ref.content,
        content = _ref$content === undefined ? '' : _ref$content,
        maxLen = _ref.maxLen,
        _ref$triggerType = _ref.triggerType,
        triggerType = _ref$triggerType === undefined ? 'focus' : _ref$triggerType,
        _ref$align = _ref.align,
        align = _ref$align === undefined ? 'rt' : _ref$align,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? { width: 200 } : _ref$style;

    var inputProps = _extends({}, commonProps, {
      maxLength: maxLength,
      htmlType: inputType ? 'password' : ''
    });

    var InputTarget = _react2.default.createElement(_next.Input, inputProps);

    // 增加气泡提示
    if (enableInputBalloon && content && content.trim()) {
      var trimContent = content.trim();
      return _react2.default.createElement(
        _next.Balloon,
        { v2: true, trigger: InputTarget, triggerType: triggerType, align: align, style: style },
        maxLen && trimContent.length > Number(maxLen) ? trimContent.slice(0, Number(maxLen)) + '...' : trimContent
      );
    }

    return InputTarget;
  };

  return InputField;
}(_vuFusionField2.default), _class.displayName = 'Input', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  fieldId: null,
  label: null
}), _class.propTypes = {
  fieldId: _propTypes2.default.string,
  label: _propTypes2.default.string
}, _class.validators = {
  idCard: _validation2.default.idCard
}, _temp);
exports.default = InputField;
module.exports = exports['default'];